module.exports = "/_next/static/images/image4-b3fd16e6a5c400329388b9a5d8868cec.png";